import { render, staticRenderFns } from "./Teleboard.vue?vue&type=template&id=fd03c426&"
import script from "./Teleboard.vue?vue&type=script&lang=js&"
export * from "./Teleboard.vue?vue&type=script&lang=js&"
import style0 from "./Teleboard.vue?vue&type=style&index=0&id=fd03c426&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports